import Slide1 from '../assets/img/carousel/slide1.jpg';
import Slide4 from '../assets/img/carousel/slide4.jpg';

import saveMyHouse from '../assets/img/InstantBuy/¿Estas en proceso de remate_.webp'
import instBuyImg from '../assets/img/InstantBuy/¿Necesitas-liquidez-inmediata-por-tu-propiedad_-.webp'
import CapHero from '../assets/img/InstantBuy/Invierte como un experto en Unidades Nuevas.webp'
import CapHeroRev from '../assets/img/InstantBuy/¿Tu propiedad no se vende por estar en mal estado_.webp'


import { MdPaid } from "react-icons/md";
import { BsBuildingFillGear } from "react-icons/bs";
import { TbHomeDollar, TbHomeHeart } from "react-icons/tb";

import imageHero2 from '../assets/img/heroHome/INCREMENTA EL VALOR DE TU PROPIEDAD.webp'
import imageHero3 from '../assets/img/heroHome/INCREMENTA EL VALOR DE TU PROPIEDAD.webp'
import imageHero5 from '../assets/img/heroHome/QUIERES SER UN CORREDOR EXITOSO.webp'

import imageMiniHome1 from '../assets/img/home/mini COMPRA INSTANTANEA.webp'
import imageMiniHome2 from '../assets/img/home/mini RENOVACION TOTAL.webp'
import imageMiniHome3 from '../assets/img/home/mini salva mi casa.webp'
import imageMiniHome4 from '../assets/img/home/mini INVERSION EN UNIDADES NUEVAS.webp'


/** Main Carousel Data */
export const mainCarouselData = [
  {
    id: 1,
    title: '¿Estás a punto de perder tu hogar?',
    desc: 'Te ayudamos a evitar el remate y recuperar tu estabilidad financiera.',
    img: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1689974575/Projects/unne/img/hero/remate3.jpg',
  },
  {
    id: 2,
    title: 'Incrementa el valor de tu propiedad',
    desc: 'Con Renovación Total, gestionamos y financiamos la remodelación para vender o arrendar más rápido.',
    img: imageHero2,
  },
  {
    id: 3,
    title: 'Invierte como un experto en Unidades Nuevas',
    desc: 'Tenemos más de 80 proyectos inmobiliarios rentables, en blanco, verde o entrega inmediata.',
    img: imageHero3,
  },
  {
    id: 4,
    title: '¿Necesitas liquidez?',
    desc: 'Nuestro producto de compra instantánea de propiedades te ofrece la solución perfecta.',
    img: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1689974937/Projects/unne/img/hero/venta.jpg',
  },
  {
    id: 5,
    title: '¿Quieres ser un corredor exitoso?',
    desc: 'Únete a la red mas importante de corredores y multiplica tus oportunidades',
    img: imageHero5,
    btn:"Ver planes"
  },

];

export const cardSolutionsData = [
  {
    id: 1,
    img: imageMiniHome1,
    title: 'Compra instantanea',
    desc: 'Te ofrecemos liquidez inmediata, por tu propiedad. Al venderla y arrendarla simultáneamente, obtienes el capital que necesitas teniendo la opción de recompra al finalizar el tiempo establecido en el contrato.',
    href: '/servicios/compra-instantanea'
  },
  {
    id: 2,
    img: imageMiniHome2,
    title: 'Renovación total',
    desc: 'Financiamos y gestionamos los arreglos o remodelación de tu propiedad, para hacerla mas atractiva, asegurando una venta o arriendo más rápido y rentable',
    href: '/servicios/renovacion-total'
  },
  {
    id: 3,
    img: imageMiniHome3,
    title: 'Salva mi casa',
    desc: 'Evita el remate y protege tu patrimonio con nuestras soluciones financieras. Tendrás la asesoría personalizada de expertos para negociar con acreedores, evitar el remate y proteger tus derechos como deudor.',
    href: '/servicios/salva-mi-casa'
  },
  {
    id: 4,
    img: imageMiniHome4,
    title: 'Inversión en unidades nuevas',
    desc: 'invierte de manera segura, con proyectos inmobiliarios en blanco, verde o de entrega inmediata, con la mayor rentabilidad del mercado y de la mano de ejecutivos expertos que te guiaran en cada paso.',
    href: '/servicios/unidades-en-remate'
  }
]

export const mainCarouselLeaseData = [
  {
    id: 1,
    title: 'Arrienda tu propiedad sin complicaciones',
    desc: 'Contamos con más de 250 corredores de propiedades en todo el territorio nacional',
    img: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1690907896/Projects/unne/img/Quiero%20arrendar/QUIERO_ARRENDAR__Arrienda_tu_propiedad_sin_complicaciones_ieiurk.webp',
  },
];

export const mainCarouselSellingData = [
  {
    id: 1,
    title: 'Vende fácil y rápido',
    desc: 'Somos la corredora de propiedades más grande del país',
    img: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1684191353/Projects/unne/img/hero/webp/slide1_rln2k2.webp',
  },
];

export const mainCarouselCapitalData = [
  {
    id: 1,
    title:'Junto a Capitalizarme.com',
    titleTwo:'creamos nuevas oportunidades',
    desc: 'Ten acceso a los proyectos inmobiliarios con mayor rentabilidad del mercado',
    // img: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1684191353/Projects/unne/img/hero/webp/slide1_rln2k2.webp',
    img: CapHero,
  },
];

export const mainCarouselInstantData = [
  {
    id: 1,
    title:'¿Necesitas liquidez',
    titleTwo:'inmediata por tu propiedad?',
    desc: 'Nuestro producto de compra instantanea te ofrece la solución ideal.',
    // img: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1684191353/Projects/unne/img/hero/webp/slide1_rln2k2.webp',
    img: instBuyImg,
  },
];

export const mainCarouselRevenewData = [
  {
    id: 1,
    title:'¿Tu propiedad no se vende',
    titleTwo:'por estar en mal estado?',
    desc: 'Nos ocupamos de los trabajos y financiación, asegurando una venta o arriendo más rápido y rentable',
    // img: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1684191353/Projects/unne/img/hero/webp/slide1_rln2k2.webp',
    img: CapHeroRev,
  },
];

export const mainCarouselLegalServicesData = [
  {
    id: 1,
    title: '¡No pierdas una venta por un trámite legal!',
    desc: 'Nuestros abogados inmobiliarios te acompañan en todo el proceso de venta',
    img: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1690837248/Projects/unne/img/Eres%20corredor/ERES_CORREDOR___SERVICIOS_LEGALES_rhfldh.webp',
  },
];

/** Tabs search by Property Data */
export const webServicesTabs = ['venta', 'arriendo ', 'arriendo_temporal'];

/* Imagenes de banco - Data */
export const BankData = [

  // {
  //   id: 6,
  //   title: 'Asset Plan',
  //   img: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1691791822/Projects/unne/img/alianzas/AssetPlann.png',
  //   href: 'https://www.assetplan.cl/',
  // },
  // {
  //   id: 7,
  //   title: 'Pulso Inversor',
  //   img: require('../assets/img/bancos/Pulso-inversor.webp'),
  //   href: 'https://www.pulsoinversor.cl/',
  // },
  {
    id: 8,
    title: 'Procanje',
    img: require('../assets/img/bancos/loader-procanje.gif'),
    href: 'https://procanje.com/',
  },
  {
    id: 9,
    title: 'Plan de salida',
    img: require('../assets/img/bancos/Plan-De-Salida.webp'),
    href: 'https://www.plandesalida.cl/',
  },
  // {
  //   id: 10,
  //   title: 'Propiteq transa',
  //   img: require('../assets/img/bancos/propiteq-transa.webp'),
  //   href: 'https://propiteq.com/',
  // },
];
/** porque unne - Arrendar Data */
export const whyUnneLeaseData = [
  {
    id: 1,
    title: '¿Por qué Unne?',
    benefits: [
      {
        id: 1,
        name: 'Te acompañamos en toda la gestión.',
        icon: 'before:content-["1"]',
      },
      {
        id: 2,
        name: 'Tu propiedad en manos del arrendatario correcto.',
        icon: 'before:content-["2"]',
      },
      {
        id: 3,
        name: 'Publicamos en los portales mas reconocidos de Chile.',
        icon: 'before:content-["3"]',
      },
      {
        id: 4,
        name: 'Asesoria Legal.',
        icon: 'before:content-["4"]',
      },
      {
        id: 5,
        name: 'Agenda tu sesión de fotos y video profesional de manera gratuita.',
        icon: 'before:content-["5"]',
      },
    ],
  },
];

export const whyUnneLeaseNewData = [
  {
    id: 1,
    title: 'Equipo de Profesionales',
    text: 'Contamos con más de 250 corredores de propiedades especializados en todo el territorio nacional.',
    icon:'customEquipo'
  },
  {
    id: 2,
    title: 'Vende en tiempo récord',
    text: 'Utilizamos un sistema inteligente que permite cruzar bases de datos de búsquedas y consultas para optimizar los tiempos de respuesta y conseguir tu arrendatario ideal en poco tiempo.',
    icon:'customMayor'
  },
  {
    id: 3,
    title: 'Mayor Alcance',
    text: 'Sincronizamos nuestras publicaciones en los 28 portales inmobiliarios más importantes del país, lo que te brindara una mayor visualización de tu propiedad.',
    icon:'customVende'
  },
];

/* Informacion del circulo en quiero-arrendar.js */
export const CircleArrendarData = [
  {
    id: 1,
    text: 'Llena el formulario',
    position: 'lg:top-0 lg:right-[19rem] md:max-lg:left-2/4 md:-top-8',
  },
  {
    id: 2,
    text: 'Te asignamos a tu ejecutivo',
    position: 'lg:right-full md:max-lg:top-10 md:max-lg:left-[24rem]',
  },
  {
    id: 3,
    text: 'Evaluación Comercial',
    position:
      'lg:right-[19rem] lg:bottom-0 md:max-lg:top-[9rem] md:max-lg:left-[28rem] ',
  },
  {
    id: 4,
    text: 'Definición de estrategias',
    position:
      'lg:bottom-0 lg:left-[19rem] md:max-lg:left-2/4 md:max-lg:-bottom-8 ',
  },
  {
    id: 5,
    text: 'Gestión Comercial',
    position: 'lg:left-full md:max-lg:bottom-10 md:max-lg:left-[24rem]',
  },
  {
    id: 6,
    text: '¡Arrendamos y recibe tu arriendo!',
    position:
      'lg:top-0 lg:left-[19rem] md:max-lg:bottom-[9rem] md:max-lg:left-[28rem] ',
  },
];

/* Informacion del circulo en quiero-vender.js */
export const CircleVenderData = [
  {
    id: 1,
    text: 'Llena el formulario',
    position: 'lg:top-0 lg:right-[19rem] md:max-lg:left-2/4 md:-top-8',
  },
  {
    id: 2,
    text: 'Te asignamos a tu Ejecutivo',
    position: 'lg:right-full md:max-lg:top-10 md:max-lg:left-[24rem]',
  },
  {
    id: 3,
    text: 'Evaluación Comercial',
    position:
      'lg:right-[19rem] lg:bottom-0 md:max-lg:top-[9rem] md:max-lg:left-[28rem]',
  },
  {
    id: 4,
    text: 'Definición de estrategias',
    position:
      'lg:bottom-0 lg:left-[19rem] md:max-lg:left-2/4 md:max-lg:-bottom-8',
  },
  {
    id: 5,
    text: 'Gestión Comercial y legal',
    position: 'lg:left-full md:max-lg:bottom-10 md:max-lg:left-[24rem]',
  },
  {
    id: 6,
    text: 'Vende y recibe tu pago!',
    position:
      'lg:top-0 lg:left-[19rem] md:max-lg:bottom-[9rem] md:max-lg:left-[28rem]',
  },
];

/** Main Carousel - Vender Data */
export const mainCarouselSellData = [
  {
    id: 1,
    title: 'Vende fácil y rápido',
    desc: '',
    img: Slide1,
  },
  {
    id: 2,
    title: 'Vende fácil y rápido',
    desc: '',
    img: Slide4,
  },
];

/** porque unne - vender Data */
export const whyUnneSellData = [
  {
    id: 1,
    title: '¿Por qué Unne?',
    benefits: [
      {
        id: 1,
        name: 'Te asesoramos de principio a fin.',
        icon: 'before:content-["1"]',
      },
      {
        id: 1,
        name: 'Tenemos la base  de clientes compradores más grande del país.',
        icon: 'before:content-["2"]',
      },
      {
        id: 1,
        name: 'Publicamos en 43 portales inmobiliarios Servicios legales.',
        icon: 'before:content-["3"]',
      },
      {
        id: 1,
        name: 'Servicios legales.',
        icon: 'before:content-["4"]',
      },
      {
        id: 1,
        name: 'Agenda tu sesión de fotos y video profesional de manera gratuita.',
        icon: 'before:content-["5"]',
      },
    ],
  },
];
/** porque unne - vender Data */
export const whyUnneSellNewData = [
  {
    id: 1,
    title: 'Equipo de Profesionales',
    text: 'Contamos con más de 250 corredores de propiedades especializados en todo el territorio nacional.',
    icon:'customEquipo',
  },
  {
    id: 2,
    title: 'Vende en tiempo récord',
    text: 'Utilizamos un sistema inteligente que permite cruzar bases de datos de búsquedas y consultas para optimizar los tiempos de respuesta y conseguir tu cliente ideal en poco tiempo.',
    icon:'customMayor',
  },
  {
    id: 3,
    title: 'Mayor Alcance',
    text: 'Sincronizamos nuestras publicaciones en los 28 portales inmobiliarios más importantes del país, lo que te brindara una mayor visualización de tu propiedad.',
    icon:'customVende',
  },
];

/** Objetives Auction page icons,title,desc */
export const ObjetivesAuctionData = [
  {
    id: 1,
    icon: 'A',
    title: 'Definición de objetivos y necesidades',
    desc: 'Establecemos el capital que dispones para tu inversión mediante una reunión de trabajo',
  },
  {
    id: 2,
    icon: 'B',
    title: 'Nos encargamos de todo el proceso',
    desc: 'Legal, pago de servicios básicos e impuestos sobre la renta, reparaciones o remodelaciòn de la propiedad',
  },
  {
    id: 3,
    icon: 'C',
    title: 'Buscamos la mejor propiedad en remate para ti',
    desc: 'Se realiza el remate y se adjudica el inmueble para posteriormente pactar la rentabilidad que generara.',
  },

  {
    id: 4,
    icon: 'D',
    title: 'El dinero retorna con la rentabilidad pactada',
    desc: 'Obtén las ganancias esperadas por tu inversión',
  },
];

/** New Property Qualities */
export const NewPropertyQualities = [
  {
    id: 1,
    title: 'Descubre',
    desc: 'Encuentra el activo que calce mejor con tu perfil financiero.',
  },
  {
    id: 2,
    title: 'Simula',
    desc: 'Elige el activo inmobiliario que más te guste y simula tu inversión de manera personalizada para proceder con la reserva de la propiedad.',
  },
  {
    id: 3,
    title: 'Relajate',
    desc: 'Gestionamos el crédito hipotecario, promesa de compra y escrituración por ti.',
  },
  {
    id: 4,
    title: 'Gana por tu inversion',
    desc: 'Administramos el arriendo de tu propiedad para que comiences a ganar por tu inversión.',
  },
];

export const StepReventions = [
  {
    id: 1,
    number:'1',
    desc: 'Estudiamos la factibilidad técnica de la remodelación',
  },
  {
    id: 2,
    number:'2',
    desc: 'Cotizamos los arreglos',
  },
  {
    id: 3,
    number:'3',
    desc: 'Analizamos la factibilidad económica',
  },
  {
    id: 4,
    number:'4',
    desc: 'Acuerdo con el propietario e inicio de remodelación',
  },
];

export const StepReventionsHow = [
  {
    id: 1,
    number:'1',
    desc: 'Se firma un contrato de prestación de servicios',
  },
  {
    id: 2,
    number:'2',
    desc: 'Se documenta la devolución de los fondos aprobados',
  },
  {
    id: 3,
    number:'3. A',
    desc: 'Firma de Recepción de trabajos.',
  },
  {
    id: 4,
    number:'3. B',
    desc: 'Se firma un mandato de administración de Arriendo',
  },
  {
    id: 5,
    number:'4',
    desc: ' Se publica el aviso en forma exclusiva para nuestro corredor Unne',
  },
];
export const StepReventionsHowSales = [
  {
    id: 1,
    number:'1',
    desc: 'Se firma un contrato de prestación de servicios',
  },
  {
    id: 2,
    number:'2',
    desc: 'Se documenta la devolución de los fondos (se deja una prenda)',
  },
  {
    id: 3,
    number:'3',
    desc: 'Firma de Recepción de trabajos.',
  },
  {
    id: 4,
    number:'4',
    desc: ' Se inicia el proceso de venta',
  },
  {
    id: 5,
    number:'5',
    desc: ' Una vez que se vende. Se descuenta el préstamo, y se reparte la plusvalía 50% y 50%. ',
  },
];

/** New Property Qualities */
export const NewCardProperty = [
  {
    id: 1,
    title: 'Evaluación',
    desc: 'Evaluamos tu perfil financiero y te brindamos las propiedades que sean más rentables y que se adapten a tus necesidades.',
  },
  {
    id: 2,
    title: 'Elige tu favorita',
    desc: 'Elige el activo inmobiliario que más te guste y simula tu inversión de manera personalizada para proceder con la reserva de la propiedad.',
  },
  {
    id: 3,
    title: 'Recibe tu propiedad',
    desc: 'Te acompañamos en todo el proceso de inversión, desde la gestión del crédito hipotecario hasta la entrega de tu propiedad.',
  }
];

/** New Property Qualities */
export const NewCardInstBuy = [
  {
    id: 1,
    title: 'Acceso rápido a capital',
    desc: 'Obtén acceso rápido a capital/liquidez inmediata.',
  },
  {
    id: 2,
    title: 'No necesitas mudarte',
    desc: 'Continúa utilizando tu propiedad sin necesidad de mudarte.',
  },
  {
    id: 3,
    title: 'Flexibilidad financiera',
    desc: ' Ideal para solucionar problemas de flujo de caja.',
  }
];

/* Asociate.js Data */
export const AssociateData = [
  {
    id: 1,
    title: 'Asóciate a la red líder de corredores en Chile',
    children: [
      {
        id: 1,
        name: 'Más de 15 cursos mensuales en el área legal y comercial',
        status: '',
      },
      {
        id: 2,
        name: 'Sesiones de Coaching comercial',
        status: '',
      },
      {
        id: 3,
        name: 'Alianzas con bancos para gestionar el financiamiento de crédito hipotecario',
        status: 'Nuevo',
      },
      {
        id: 4,
        name: 'Desarrollo de Página Web personalizada',
        status: 'Nuevo',
      },
      {
        id: 5,
        name: 'Servicios Legales',
        status: '',
      },
      {
        id: 6,
        name: 'Alianza con Assetplan, para aumentar tu cartera e ingresos',
        status: 'Nuevo',
      },
      {
        id: 7,
        name: 'Cuentas con un Vendeid para que las consultas te lleguen directamente',
        status: '',
      },
      {
        id: 8,
        name: 'Sistema de Canje Inteligente',
        status: 'Nuevo',
      },
      {
        id: 9,
        name: 'Conserva el 100% de tu comisión',
        status: '',
      },
      {
        id: 10,
        name: 'Oportunidades de Inversión para tus clientes',
        status: 'Nuevo',
      },
    ],
  },
];

/* Imagenes de los portales - Data */
export const PortalData = [
  {
    id: 1,
    title: 'Portal Inmobiliario',
    img: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1690916855/Projects/unne/img/portales/portal_in_1_alfly5.webp',
    href: 'https://www.portalinmobiliario.com/',
  },
  {
    id: 2,
    title: 'Yapo',
    img: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1690912561/Projects/unne/img/portales/yapo_t81kzz.png',
    href: 'https://new.yapo.cl/',
  },
  {
    id: 3,
    title: 'Enlace Inmobiliario',
    img: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1690912562/Projects/unne/img/portales/enlace_inmobiliario_io3jab.png',
    href: 'https://www.enlaceinmobiliario.cl/',
  },
  {
    id: 4,
    title: 'Toc toc',
    img: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1690912561/Projects/unne/img/portales/toctoc_wjieec.png',
    href: 'https://www.toctoc.com/',
  },
  // {
  //   id: 5,
  //   title: 'Zoom Inmobiliario',
  //   img: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1690912562/Projects/unne/img/portales/zoom_srnwgd.png',
  //   href: 'https://www.zoominmobiliario.com/',
  // },
  // {
  //   id: 6,
  //   title: 'Portal Terreno',
  //   img: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1690912562/Projects/unne/img/portales/portal_terreno_r8qswq.png',
  //   href: 'https://www.portalterreno.com/cl/',
  // },
  {
    id: 7,
    title: 'Doomos',
    img: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1690912562/Projects/unne/img/portales/doomos_rt0slv.png',
    href: 'https://www.doomos.cl/',
  },
  {
    id: 8,
    title: 'Proppit',
    img: 'https://res.cloudinary.com/drju7lpxl/image/upload/v1778173509/unne/logo_proppit_avxrcr.png',
    href: 'hhttps://proppit.com/',
  },
  // {
  //   id: 9,
  //   title: 'ICasas',
  //   img: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1690912561/Projects/unne/img/portales/iCasas_w1okpp.png',
  //   href: 'https://www.icasas.cl/',
  // },
  {
    id: 10,
    title: 'Chile Propiedades',
    img: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1690915721/Projects/unne/img/portales/chilepropiedades_edrxrr.png',
    href: 'https://chilepropiedades.cl/',
  },
  {
    id: 11,
    title: 'Go placeit',
    img: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1711396456/Projects/unne/img/portales/GoPlaceit_wyfzja.webp',
    href: 'https://www.goplaceit.com/cl/',
  },
];

/* Asociate.js Data */
export const AssociateCardData = [
  // {
  //   id: 1,
  //   title: 'Contrata nuestros servicios legales',
  //   desc: 'Contamos con abogados especialistas en asesorías inmobiliarias que te guiaran en todo el proceso de la venta o arriendo de tu propiedad.',
  //   icon: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1692043409/Projects/unne/img/Eres%20corredor/iconos/Asociate-_servicios_legales_hrcmon.png',
  //   href: '/eres-corredor/servicios-legales',
  //   children: [
  //     {
  //       id: 1,
  //       name: 'Alianzas con bancos para gestionar el financiamiento',
  //     },
  //     {
  //       id: 2,
  //       name: 'Intermediarios en los procesos de Canje',
  //     },
  //     {
  //       id: 3,
  //       name: 'Inversión de Remate Seguro',
  //     },
  //   ],
  // },
  {
    id: 2,
    title: 'Academia Unne',
    desc: 'Tenemos un programa dirigido por especialista del área del corretaje, que te brindara los conocimientos necesarios para ser un profesional.',
    icon: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1692043408/Projects/unne/img/Eres%20corredor/iconos/Asociate_-_academia_unne_sqbzhl.png',
    href: '/eres-corredor/academia-unne',
    children: [
      {
        id: 1,
        name: 'Capacitaciones comerciales',
      },
      {
        id: 2,
        name: 'Capacitaciones legales',
      },
      {
        id: 3,
        name: 'Capacitaciones de sistema',
      },
    ],
  },
  {
    id: 3,
    title: 'Desarrollo de Páginas Web',
    desc: 'Desarrollo y diseño de sitios web para corredores inmobiliarios, con la que podrás sincronizar tus publicaciones con nuestro integrador y hacer crecer tu marca.',
    icon: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1692043409/Projects/unne/img/Eres%20corredor/iconos/Asociate_-_p%C3%A1gina_web_esccix.png',
    href: '',
    children: [
      {
        id: 1,
        name: 'Diseño personalizado',
      },
      {
        id: 2,
        name: 'Sitios web adaptable para varios dispositivos',
      },
      {
        id: 3,
        name: 'Sincronización de tus publicaciones en un clic',
      },
    ],
  },
  {
    id: 4,
    title: 'Banco de Canje Avanzado',
    desc: 'Sistema inteligente que te ayudara a conseguir de manera sencilla y eficaz la propiedad con las características adecuadas o al cliente interesado.',
    icon: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1692043409/Projects/unne/img/Eres%20corredor/iconos/Asociate_-_banco_de_canje_eddif6.png',
    href: '',
    children: [
      {
        id: 1,
        name: 'Ampliar la cartera de clientes',
      },
      {
        id: 2,
        name: 'Aumenta tus ingresos',
      },
      {
        id: 3,
        name: 'Proceso seguro y transparente',
      },
    ],
  },
  {
    id: 5,
    title: 'Oportunidades de Inversión',
    desc: 'Tus clientes contaran con productos de inversión de remate seguro y unidades nuevas',
    icon: 'https://res.cloudinary.com/dvdb33uyj/image/upload/v1692043409/Projects/unne/img/Eres%20corredor/iconos/Asociate_-_inversi%C3%B3n_p3vi2u.png',
    href: '/soy-inversionista/unidades-en-remate',
    children: [],
  },
];

/** Main Carousel Data */
export const CarouselLegalServicesData = [
  {
    id: 1,
    title: 'Enfócate en vender, alivia tu carga con Servicios Legales Unne',
    desc: 'No pierdas una venta por no tener la asesoría necesaria y entrega un servicio profesional.',
    img: Slide1,
  },
  {
    id: 2,
    title: 'Enfócate en vender, alivia tu carga con Servicios Legales Unne',
    desc: 'No pierdas una venta por no tener la asesoría necesaria y entrega un servicio profesional.',
    img: Slide4,
  },
];

/** porque unne - vender Data */
export const LegalServicesData = [
  {
    id: 1,
    title: 'Profesionales',
    desc: 'Contamos con un equipo de profesionales que te guiaran y apoyaran en todo el proceso legal.',
    color: 'bg-[#FDDC97]',
  },
  {
    id: 2,
    title: 'Gestión',
    desc: 'Nuestro equipo gestionará cada paso del proceso del crédito hipotecario hasta el retiro del pago del vale vista.',
    color: 'bg-[#F7B092]',
  },
  {
    id: 3,
    title: 'Cero Filas',
    desc: 'Firma programada en notaria, para que tu tiempo lo utilices en otras cosas importantes.',
    color: 'bg-[#D6D5D5]',
  },
];

/** porque unne - vender Data */
export const TradingProcessData = [
  {
    id: 1,
    title: 'Proceso de Compraventa de inmuebles',
    doc: 'Sin documentación',
    uf: '6,8',
    process: [
      'Redacción de promesa e instrucciones notariales.',
      'Coordinación bancaria.',
      'Revisión de escritura pública de compraventa redactada por banco.',
      'Redacción de instrucciones notariales de compraventa.',
      'Coordinación notarial.',
      'Monitoreo en CBR respectivo.',
      'Orientación legal en horario hábil.',
    ],
  },
];

/** porque unne - vender Data */
export const MoreServicesData = [
  {
    id: 1,
    title: 'Nuestros Servicios',
    process: [
      'Proceso de Compraventa de inmuebles',
      'Proceso de Compraventa de inmuebles al Contado',
      'Redacción de Promesa de compraventa e instrucciones notariales',
      'Revisión de promesa de compraventa',
      'Informe de Estudio de Títulos',
      'Solución de reparos',
      'Redacción de poder especial de venta o compraventa',
      'Redacción escrituras de cancelación, transacción, renuncia de gananciales, etc.',
      'Redacción escritura pública de Compraventa',
      'Revisión escritura pública Compraventa redactada por banco',
      'Redacción instrucciones notariales de Compraventa',
      'Redacción contrato de arrendamiento estándar',
      'Redacción carta de término de contrato de arrendamiento',
    ],
  },
  {
    id: 2,
    title: 'Juicios',
    process: [
      'Cobro de honorarios correspondientes a la comisión del corredor',
      'Terminación de contratos de arrendamiento por no pagos de las rentas ',
      'Restitución de inmuebles por abandono del arrendatario',
      'Precario',
      'Incumplimientos de contrato de promesa',
      'Conflictos a la Ley No 19.537 de Copropiedad Inmobiliaria',
      'Representación en segunda instancia',
    ],
  },
];


/** Plans card data */
export const plansCardData = [
  {
    id: 1,
    title: 'Plan Inteligente',
    commission: '25%',
    benefits: [
      '5% del valor del arriendo mensual',
      'Publicación en 30 portales inmobiliarios',
      'Ofertas formales con garantía Asesoría legal',
      'Acta de entrega con respaldo fotográfico',
      'Verificación de pago de servicios y GGCC',
      'Gestión de reparaciones y mantención',
    ],
  },
  {
    id: 2,
    title: 'Plan con garantía',
    commission: '50%',
    benefits: [
      '7,5% del valor del arriendo mensual',
      '6 meses de arriendo en caso de no pago',
      'Publicación en 30 portales inmobiliarios',
      'Ofertas formales con garantía Asesoría legal',
      'Acta de entrega con respaldo fotográfico',
      'Verificación de pago de servicios y GGCC',
      'Gestión de reparaciones y mantención',
    ],
  },
];


/** Company Qualities */
export const companyQualities = [
  {
    id: 1,
    title: 'Especialistas',
    desc: 'Te brindamos la mejor atención de la mano de especialistas del corretaje inmobiliario y profesionales del area legal.',
  },
  {
    id: 2,
    title: 'Rapidez',
    desc: 'Arrendamos tu propiedad en tiempo record, para que no tengas perdidas por tu inversión.',
  },
  {
    id: 3,
    title: 'Tranquilidad',
    desc: 'Desde el primer paso, nos encargamos de gestionar tu propiedad de inversión, para que ocupes tu tiempo en lo que te gusta.',
  },
];


/** Property Managment steps */
export const propertyManagmentData = [
  {
    id: 1,
    span: 'Escoge tu plan',
    desc: 'Administración Inteligente o con Garantía',
  },
  {
    id: 2,
    span: 'Disfruta de los beneficios',
    desc: 'y la tranquilidad, que nosotros nos encargamos del resto',
  },
  {
    id: 3,
    span: 'Comienza a recibir tu arriendo',
    desc: 'sin falta los primeros 5 dias del mes',
  },
];

export const UserExperience = [
  {
    id:1,
    avatar:'https://res.cloudinary.com/dvdb33uyj/image/upload/v1691681682/Projects/unne/img/experienciaUsuarios/mujer.png',
    names: 'Anamaria ',
    last_name:'Espinoza',
    type:'Asociada Unne ',
    comment:'Estoy muy contenta de pertenecer a este gran equipo, siempre he tenido excelente atención como asociada, mis dudas son respondidas rápidamente y de forma clara. Gracias a mis publicaciones en Unne he tenido muy buena exposición, he vendido y arrendado varias propiedades en los dos años que estoy trabajando junto a ustedes. Les deseo un muy feliz aniversario y que sean muchos más. ',
  },
  {
    id:2,
    avatar:'https://res.cloudinary.com/dvdb33uyj/image/upload/v1691681682/Projects/unne/img/experienciaUsuarios/mujer.png',
    names: 'Ximena ',
    last_name:'Vargas',
    type:'Asociada Unne ',
    comment:'Hace aproximadamente un año que contraté UNNE y, además de lo completo del servicio, lo cual no he visto en otro proveedor, sin duda, la atención directa y diligente de los ejecutivos, es lo mejor.',
  },
  {
    id:3,
    avatar:'https://res.cloudinary.com/dvdb33uyj/image/upload/v1691681682/Projects/unne/img/experienciaUsuarios/mujer.png',
    names: 'Anita ',
    last_name:'Lizárraga',
    type:'Asociada Unne',
    comment:'Trabajamos con Unne hace más de 4 años muy conformes sobre todo que están siempre dando valor agregado a sus asociados. ',
  },
  {
    id:4,
    avatar:'https://res.cloudinary.com/dvdb33uyj/image/upload/v1691681678/Projects/unne/img/experienciaUsuarios/hombre.png',
    names: 'Luis Ramon',
    last_name:'Urdaneta Perez',
    type:'Asociado Unne',
    comment:'Excelente Gestor Inmobiliario, he visto el crecimiento de mi emprendimiento, vertiginosamente. Espacio donde cuentas además de capacitación constante, solución inmediata a tus solicitudes. Unne es por lejos el mejor gestor inmobiliario de todo Chile. ¡Felicidades!',
  },
  {
    id:5,
    avatar:'https://res.cloudinary.com/dvdb33uyj/image/upload/v1691681682/Projects/unne/img/experienciaUsuarios/mujer.png',
    names: 'Trinidad ',
    last_name:'Silva Meyer',
    type:'Asociada Unne ',
    comment:'Excelente servicio y atención de los ejecutivos de UNNE. Estoy con ellos casi desde sus inicios y no me canso de recomendarlo a mis águila y colegas corredores de propiedades!!',
  },
  {
    id:6,
    avatar:'https://res.cloudinary.com/dvdb33uyj/image/upload/v1691681682/Projects/unne/img/experienciaUsuarios/mujer.png',
    names: 'Carmen',
    last_name:'Valiente',
    type:'Asociada Unne ',
    comment:'Mi experiencia con la empresa Unne ha sido excelente, comunicación fluida, capacitaciones permanentes, tanto del uso de la plataforma Unne, como del ámbito de corretaje de propiedades., área legal, comercial, etc.. Gracias Unne.',
  },
  {
    id:7,
    avatar:'https://res.cloudinary.com/dvdb33uyj/image/upload/v1691681678/Projects/unne/img/experienciaUsuarios/hombre.png',
    names: 'Jimmy  ',
    last_name:'Gomez',
    type:'Asociada Unne ',
    comment:'Desde que empecé con Unne, he notado una notable diferencia en la llegada de clientes. Gracias a su plataforma, he logrado arrendar y vender propiedades de manera más rápida y efectiva. ¡Estoy muy satisfecho con los resultados obtenidos!',
  }
];

export const UserExperServicesLegal = [
  {
    id: 1,
    avatars:'https://res.cloudinary.com/dvdb33uyj/image/upload/v1691681678/Projects/unne/img/experienciaUsuarios/hombre.png',
    name: 'Ángel ',
    last_names:'Bustamante',
    types: 'Asociado Unne',
    extra:'',
    comments: 'Ellos se hicieron cargo y lideraron el proceso que tuvo bastantes obstáculos e imprevistos, sin embargo la operación resultó exitosa para todas las partes. Muy agradecido de Nabi, Felipe y Pablo.'
  },
  {
    id: 2,
    avatars:'https://res.cloudinary.com/dvdb33uyj/image/upload/v1691681678/Projects/unne/img/experienciaUsuarios/hombre.png',
    name: 'Edgar ',
    last_names:'Nunez',
    extra:'E2 Gestión Inmobiliaria  ',
    types: 'Asociado Unne',
    comments: 'Excelente equipo legal, un plus para quienes trabajamos de manera independiente. Están siempre dispuestos a ayudar y resolver dudas. 100% recomendados!!!'
  },
  {
    id: 3,
    avatars:'https://res.cloudinary.com/dvdb33uyj/image/upload/v1691681682/Projects/unne/img/experienciaUsuarios/mujer.png',
    name: 'Nandy ',
    last_names:'Salazar',
    extra:'High City Propiedades',
    types: 'Asociado Unne',
    comments: 'Un saludo cordial para todo el equipo Unne, me siento complacida de sus servicios del área legal, logrando exitosas negociaciones y de sus oficinas las cuales facilitan el buen desempeño con nuestros clientes y los procesos de cierre de Negocios. Un abrazo equipo Unne.'
  },
  
];